import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  Switch,
  TextField,
  Typography,
  Dialog,
  DialogContent,
  Link,
  List, ListItem, ListItemIcon, ListItemText
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { useSnackBar } from "../../FlowBuilder/Common/SnackBar/index.tsx";
import SearchableDropdown from "../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx";
import { ConstantActions, ManagementActions } from "../../../Services/_actions";
import { useNavigate, useParams } from "react-router";
import { PaginatedResponse, UserObject } from "../../../interfaces/Management.interface.ts";
import { useRecoilState, useRecoilValue } from 'recoil';
import { stateListAtom } from "../../../Services/_states/Constant.js";
import { createUserFormDataAtom, createUserFormDataErrorsAtom } from "../../../Services/_states/index.js";
import OrganisationDropdown from "../../Shared/OrganisationDropdown/index.tsx";
import { validatePassword, validateUserForm } from "../validations.ts";
interface CreateUserFormProps {
  isAccountPage: boolean;
}

const CreateUserForm: React.FC<CreateUserFormProps> = ({ isAccountPage = false }) => {
  const constantActions = ConstantActions();
  const actions = ManagementActions();
  const { showSnackBar } = useSnackBar();
  const { mode } = useParams();
  const navigate = useNavigate();
  const stateList = useRecoilValue(stateListAtom);
  const [formData, setFormData] = useRecoilState(createUserFormDataAtom);
  const [errors, setErrors] = useRecoilState(createUserFormDataErrorsAtom);
  const [cityOptions, setCityOptions] = useState([]);
  const [organisationRes, setOrganisationRes] = useState < PaginatedResponse > ({ list: [], pages: 0, count: 0 });
  const [organisationFilter, setOrganisationFilter] = useState({ page: 0, search: "" });
  const [organisationIsLoading, setOrganisationIsLoading] = useState(false);
  const [profileResponse, setProfileResponse] = useState < PaginatedResponse > ({ count: 0, list: [] });
  const [profileFilter, setProfileFilter] = useState < { organisationId?: string, page?: number, search?: string } > ({ page: 0, search: "", organisationId: "" });
  const [profileIsLoading, setProfileIsLoading] = useState(false);
  // const [roleResponse, setRoleResponse] = useState < PaginatedResponse > ({ count: 0, list: [] });
  // const [roleFilter, setRoleFilter] = useState < { organisationId?: string, page?: number, search?: string } > ({ page: 1, search: "", organisationId: "" });
  // const [roleIsLoading, setRoleIsLoading] = useState(false);
  // const [passwordRules, setPasswordRules] = useState({
  //   minLength: false,
  //   uppercase: false,
  //   lowercase: false,
  //   number: false,
  //   specialChar: false,
  //   noCommonWords: true,
  //   noUsernameSubstring: false,
  //   // expiryEnforced: true,
  //   // lockoutEnforced: true,
  //   // passwordReuseLimitExceeded: false
  // });



  const fetchStates = async () => {
    try {
      await constantActions.getStateList();
    } catch (error) {
      showSnackBar('Error fetching states:', 'error');

    }
  };

  const fetchCities = async (stateId: string) => {
    try {
      const res = await constantActions.getCityByState(stateId);
      setCityOptions(res);
    } catch (error) {
      showSnackBar('Error fetching cities:', 'error');

    }
  };

  // const fetchOrganisations = async (filterObj) => {
  //   setOrganisationIsLoading(true);
  //   try {
  //     const res = await constantActions.getOrganisationsWithPagination(filterObj);
  //     if (res?.status === 200 && res?.data) {
  //       setOrganisationRes(res.data);
  //     } else {
  //       showSnackBar('Unexpected response status or data:', 'error');
  //     }
  //   } catch (error) {
  //     showSnackBar('Failed to fetch organizations:', 'error');

  //   }
  //   setOrganisationIsLoading(false);
  // };

  const loadMoreOrganisation = async () => {
    if (organisationFilter.page < (organisationRes.pages || 0)) {
      setOrganisationIsLoading(true);
      let listData: any[] = Array.isArray(organisationRes.list) ? [...organisationRes.list] : [];
      const data = { ...organisationFilter, page: organisationFilter.page + 1 };
      try {
        const res = await constantActions.getOrganisationsWithPagination(data);
        if (res?.status === 200 && res?.data?.list && Array.isArray(res.data.list)) {
          listData = [...listData, ...res.data.list];
          setOrganisationRes({ ...res.data, list: listData });
          setOrganisationFilter(data);
        } else {
          showSnackBar('Unexpected response structure or status:', 'error');

        }
      } catch (error) {
        showSnackBar('Error loading more organizations:', 'error');
      } finally {
        setOrganisationIsLoading(false);
      }
    }
  };

  const handleSearchOrganisation = (query) => {
    const updatedFilter = { ...organisationFilter, search: query || '', page: 0 };
    setOrganisationFilter(updatedFilter);
    // fetchOrganisations(updatedFilter);
  };



  const getProfileList = async (filterObj: { organisationId?: string, page?: number, search?: string }) => {
    setProfileResponse({ ...profileResponse, list: [] });
    setProfileIsLoading(true);
    try {
      const res = await actions.getProfileList(filterObj);
      if (res?.status === 200) {
        setProfileResponse(res?.data || {});
      }
    } catch (error) {
      throw error;
    }
    setProfileIsLoading(false);
  };
  const loadMoreProfile = async () => {
    if ((profileFilter.page || 0) < (profileResponse.pages || 0)) {
      setProfileIsLoading(true);
      let listData: any[] = Array.isArray(profileResponse?.list) ? [...profileResponse?.list] : [];
      const data = { ...profileFilter, page: (profileFilter.page || 0) + 1 };
      try {
        const res = await actions.getProfileList(data);
        if (res?.status === 200 && res?.data?.list && Array.isArray(res.data.list)) {
          listData = [...listData, ...res.data.list];
          setProfileResponse({ ...res.data, list: listData });
          setProfileFilter(data);
        } else {
          showSnackBar('Unexpected response structure or status:', 'error');
        }
      } catch (error) {
        showSnackBar('Error loading more organizations:', 'error');
      } finally {
        setProfileIsLoading(false);
      }
    }
  };

  const handleSearchProfile = (query) => {
    const updatedFilter = { ...profileFilter, search: query || '', page: 0 };
    setProfileFilter(updatedFilter);
    getProfileList(updatedFilter);
  };

  // const getRoleList = async (filterObj: { organisationId?: string, page?: number, search?: string }) => {
  //   setRoleIsLoading(true);
  //   try {
  //     const res = await actions.getRoleList(filterObj);
  //     setRoleResponse(res?.status === 200 ? res?.data || {} : {});
  //   } catch (error) {
  //     showSnackBar('Error fetching roles:', 'error');

  //   } finally {
  //     setRoleIsLoading(false);
  //   }
  // };
  // const loadMoreRole = async () => {
  //   if ((roleFilter.page || 0) < (roleResponse.pages || 0)) {
  //     setRoleIsLoading(true);
  //     let listData: any[] = Array.isArray(roleResponse?.list) ? [...roleResponse?.list] : [];
  //     const data = { ...roleFilter, page: (roleFilter.page || 0) + 1 };
  //     try {
  //       const res = await actions.getRoleList(data);
  //       if (res?.status === 200 && res?.data?.list && Array.isArray(res?.data?.list)) {
  //         listData = [...listData, ...res.data.list];
  //         setRoleResponse({ ...res.data, list: listData });
  //         setRoleFilter(data);
  //       } else {
  //         showSnackBar('Unexpected response structure or status:', 'error');
  //       }
  //     } catch (error) {
  //       showSnackBar('Error loading more organizations:', 'error');
  //     } finally {
  //       setRoleIsLoading(false);
  //     }
  //   }
  // };

  const handleSearchRole = (query) => {
    const updatedFilter = { ...roleFilter, search: query || '', page: 0 };
    setRoleFilter(updatedFilter);
    getProfileList(updatedFilter);
  };


    const handleSelectOrganisation = async (option: { organisation_id?: string } | null) => {
    setFormData(prev => ({
      ...prev,
      organisation: option,
      profile: null,
      role: null
    }));

    const orgId = option?.organisation_id || '';
    await getProfileList({ ...profileFilter, organisation_id: orgId });
    setProfileFilter(prev => ({ ...prev, organisationId: orgId }));

    // await getRoleList({ ...roleFilter, organisationId: orgId });
    // setRoleFilter(prev => ({ ...prev, organisationId: orgId }));
  };


  useEffect(() => {
    if (!stateList || stateList.length === 0) {
      fetchStates();
    }
  }, [stateList]);


  // useEffect(() => {
  //   fetchStates();
  //   // fetchOrganisations(organisationFilter);
  // }, []);

  const handleStateChange = (state: any) => {
    setFormData({ ...formData, location: [{ state: state, city: [] }] });
    fetchCities(state?.id);
  };

  const handleInputChange = (field: string, value: string) => {
    setFormData({ ...formData, [field]: value });

    switch (field) {
      case "first_name":
        setErrors((prev) => ({
          ...prev,
          first_name: value.length > 15 ? "First name must be 15 characters or less" : ""
        }));
        break;
      case "last_name":
        setErrors((prev) => ({
          ...prev,
          last_name: value.length > 15 ? "Last name must be 35 characters or less" : ""
        }));
        break;
      case "username":
        setErrors((prev) => ({
          ...prev,
          username: value.length > 35 ? "Username must be 5 characters or less" : ""
        }));
        break;
      case "email":
        setErrors((prev) => ({
          ...prev,
          email: value.length > 50 ? "Email must be 50 characters or less" : ""
        }));
        break;
      case "mobile":
        let mobileError = "";

        if (/[^0-9]/.test(value)) {
          mobileError = "Characters are not allowed";
        }
        else if (value.length !== 12) {
          mobileError = "Mobile number must be exactly 12 digits";
        }
        setErrors((prev) => ({
          ...prev,
          mobile: mobileError
        }));
        break;
      // case "password":
      //   const { isValid, rules } = validatePassword(value, formData?.username || "");
      //   setPasswordRules(rules);
      //   setErrors((prev) => ({
      //     ...prev,
      //     password: isValid ? "" : "Password does not meet all requirements",
      //   }));
      //   break;
      // default:
      //   setErrors((prev) => ({ ...prev, [field]: "" }));
      //   break;
    }
  };


  const handleSubmit = async () => {
    try {
      const dataToPost = {
        organisation: formData?.organisation?.organisation_id,
        username: formData?.username || '',
        // password: formData?.password,
        // confirm_password: formData?.confirm_password,
        first_name: formData?.first_name,
        last_name: formData?.last_name,
        email: formData?.email,
        // role: formData?.role?.id,
        profile: formData?.profile?.id,
        mobile: formData?.mobile,
        is_superuser: formData?.is_superuser,
        // location:
        //   [{ state: "Maharashtra", "city": ["Mumbai", "Pune"] },
        //   { state: "Delhi", "city": [] }],
        user_type: formData?.profile?.name || '',
      }
      let result = validateUserForm(dataToPost);
      setErrors(result);
      if (!(Object.keys(result).length === 0)) return;
      if (mode === "edit") {
        let res: any = await actions.updateUser({ ...dataToPost, id: formData?.id });
         console.log("Update User API Response:", res);
        if (res?.status === 200) {
          showSnackBar('User updated successfully!', 'success');
          navigate(-1);
        } else {
          showSnackBar('User is not updated successfully!', 'error');
        }
      } else {
        let res: any = await actions.createUser(dataToPost);
        console.log("Create User API Response:", res);
        if (res?.status === 200) {
          showSnackBar('User created successfully!', 'success');
          navigate('/r/management/user-list/');
        } else if (res?.data?.general_error?.username) {
          const usernameError =
            res?.data?.general_error?.username?.[0] || 'User is not created successfully!';

          setErrors((prev) => ({
            ...prev,
            username: usernameError,
          }));

          showSnackBar(usernameError, 'error');
        } else {
          showSnackBar('User is not created successfully!', 'error');
        }
      }
   } catch (error: any) {
  console.log("Create User Error:", error);

  const usernameError =
    error?.response?.data?.data?.general_error?.username?.[0] ||
    error?.response?.data?.general_error?.username?.[0] ||
    "";

  const backendError =
    error?.response?.data?.data?.general_error ||
    error?.response?.data?.message ||
    error?.message ||
    "Something went wrong";

  if (usernameError) {
    setErrors((prev) => ({
      ...prev,
      username: usernameError,
    }));

    showSnackBar(usernameError, "error");
  } else {
    showSnackBar(
      typeof backendError === "string"
        ? backendError
        : "Something went wrong!",
      "error"
    );
  }
}
  };

  useEffect(() => {
    if (isAccountPage || mode !== "edit") return;

    if (!formData?.id) {
      navigate("/r/management/user-list/");
    }
    // if (!formData.organisation) {
    //   setFormData(prevFormData => ({
    //     ...prevFormData,
    //     organisation: prevFormData?.profile?.organisation || null,
    //   }));
    // }
  }, []);

  return (
    <Box
      sx={mode !== undefined ? {
        padding: "20px",
        maxWidth: "900px",
        margin: "auto",
        backgroundColor: "#f9f9f9",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      } : {}
      }
    >
      <Typography
        variant="h5"
        component="h1"
        sx={{
          marginBottom: "20px",
          textAlign: "center",
          fontWeight: "bold",
        }}
      >
        {`${mode === "edit" ? "Edit User" : "Create New User"}`}
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={
              <Typography component="span">
                First Name <span style={{ color: 'red' }}>*</span>
              </Typography>
            }
            placeholder="Enter First Name"
            variant="outlined"
            size="small"
            value={formData?.first_name || ''}
            onChange={(e) => handleInputChange("first_name", e.target.value)}
            error={!!errors?.first_name}
            helperText={errors?.first_name}
            inputProps={{ maxLength: 25 }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={
              <Typography component="span">
                Last Name <span style={{ color: 'red' }}>*</span>
              </Typography>
            }
            placeholder="Enter Last Name"
            variant="outlined"
            size="small"
            value={formData.last_name}
            onChange={(e) => handleInputChange("last_name", e.target.value)}
            error={!!errors?.last_name}
            helperText={errors?.last_name}
            inputProps={{ maxLength: 15 }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={
              <Typography component="span">
                Username <span style={{ color: 'red' }}>*</span>
              </Typography>
            }
            placeholder="Enter Username"
            variant="outlined"
            size="small"
            value={formData?.username || ''}
            onChange={(e) => handleInputChange("username", e.target.value)}
            error={!!errors?.username}
            helperText={errors?.username}
            inputProps={{ maxLength: 35 }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={
              <Typography component="span">
                Email <span style={{ color: 'red' }}>*</span>
              </Typography>
            }
            placeholder="Enter Email"
            variant="outlined"
            size="small"
            value={formData?.email || ''}
            onChange={(e) => handleInputChange("email", e.target.value)}
            error={!!errors?.email}
            helperText={errors?.email}
            inputProps={{ maxLength: 50 }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={
              <Typography component="span">
                Mobile Number <span style={{ color: 'red' }}>*</span>
              </Typography>
            }
            placeholder="Enter Mobile Number"
            variant="outlined"
            size="small"
            value={formData?.mobile || ''}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, '');
              handleInputChange("mobile", value);
            }}
            error={!!errors?.mobile}
            helperText={errors?.mobile}
            inputProps={{
              maxLength: 12,
              inputMode: "numeric",
              pattern: "[0-9]*"
            }}
          />

        </Grid>
        <Grid item xs={12} sm={6}>
          <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
            <Typography>Is Super User</Typography>
            <Switch
              disabled={isAccountPage}
              checked={formData?.is_superuser || false}
              onChange={(e: any) => {
                handleInputChange("is_superuser", e.target.checked)
              }}
              inputProps={{ 'aria-label': 'Is Super user' }}
            />
          </Box>
        </Grid>
        {mode !== undefined &&
          <>
            <Grid item xs={12} sm={4}>
              <OrganisationDropdown
                value={formData?.organisation || null}
                onChange={(org) => handleSelectOrganisation(org)}
                error={!!errors.organisation}
                errorMessage={errors?.organisation}
                disabled={isAccountPage}
                label={
                  <Typography component="span">
                    Select Organisation <span style={{ color: 'red' }}>*</span>
                  </Typography>
                }
                // sx={{ mb: 3 }}
                sx={{ margin: 0, padding: 0 }}
                autoSelectValue={false}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <SearchableDropdown
                options={profileResponse?.list || []}
                // label="Assign Profile"
                label={
                  <Typography component="span">
                    Assign Profile <span style={{ color: 'red' }}>*</span>
                  </Typography>
                }
                labelKey="name"
                value={formData?.profile || null}
                fetchMoreOptions={(profileFilter?.page || 0) < (profileResponse?.pages || 0) ? loadMoreProfile : undefined}
                onSearch={handleSearchProfile}
                onChange={(profile) => setFormData({ ...formData, profile: profile })}
                loading={profileIsLoading}
                sx={{ margin: 0, padding: 0 }}
                error={!!errors?.profile}
                errorMessage={errors?.profile}
                disabled={isAccountPage}
              />
            </Grid>
            {/* <Grid item xs={12} sm={4}>
              <SearchableDropdown
                options={roleResponse?.list || []}
                label="Assign Role"
                labelKey="name"
                value={formData?.role || null}
                fetchMoreOptions={(roleFilter?.page || 0) < (roleResponse?.pages || 0) ? loadMoreRole : undefined}
                onSearch={handleSearchRole}
                onChange={(profile) => setFormData({ ...formData, role: profile })}
                loading={roleIsLoading}
                sx={{ margin: 0, padding: 0 }}
                disabled={isAccountPage}
              />
            </Grid> */}
          </>
        }
        {/* <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={
              <Typography component="span">
                Password <span style={{ color: 'red' }}>*</span>
              </Typography>
            }
            type="password"
            placeholder="Enter Password"
            variant="outlined"
            size="small"
            value={formData?.password || ''}
            onChange={(e) => handleInputChange("password", e.target.value)}
            error={!!errors?.password}
            helperText={errors?.password}
          /> 
          <Typography variant="subtitle1" style={{ marginTop: "5px" }}>
            Password must meet the following requirements:
          </Typography>
          <Box mt={1} mb={1}>
            <Typography variant="caption" display="flex" alignItems="center" color={passwordRules?.minLength ? 'success.main' : 'error.main'}>
              {passwordRules?.minLength ? <CheckCircleIcon fontSize="small" sx={{ mr: 0.5 }} /> : <CancelIcon fontSize="small" sx={{ mr: 0.5 }} />}
              At least 12 characters
            </Typography>
            <Typography variant="caption" display="flex" alignItems="center" color={passwordRules?.uppercase ? 'success.main' : 'error.main'}>
              {passwordRules?.uppercase ? <CheckCircleIcon fontSize="small" sx={{ mr: 0.5 }} /> : <CancelIcon fontSize="small" sx={{ mr: 0.5 }} />}
              At least one uppercase letter (A-Z)
            </Typography>
            <Typography variant="caption" display="flex" alignItems="center" color={passwordRules?.lowercase ? 'success.main' : 'error.main'}>
              {passwordRules?.lowercase ? <CheckCircleIcon fontSize="small" sx={{ mr: 0.5 }} /> : <CancelIcon fontSize="small" sx={{ mr: 0.5 }} />}
              At least one lowercase letter (a-z)
            </Typography>
            <Typography variant="caption" display="flex" alignItems="center" color={passwordRules?.number ? 'success.main' : 'error.main'}>
              {passwordRules?.number ? <CheckCircleIcon fontSize="small" sx={{ mr: 0.5 }} /> : <CancelIcon fontSize="small" sx={{ mr: 0.5 }} />}
              At least one number (0-9)
            </Typography>
            <Typography variant="caption" display="flex" alignItems="center" color={passwordRules?.specialChar ? 'success.main' : 'error.main'}>
              {passwordRules?.specialChar ? <CheckCircleIcon fontSize="small" sx={{ mr: 0.5 }} /> : <CancelIcon fontSize="small" sx={{ mr: 0.5 }} />}
              At least one special character (@$!%*?&)
            </Typography>
            <Typography variant="caption" display="flex" alignItems="center" color={passwordRules?.noCommonWords ? 'success.main' : 'error.main'}>
              {passwordRules?.noCommonWords ? <CheckCircleIcon fontSize="small" sx={{ mr: 0.5 }} /> : <CancelIcon fontSize="small" sx={{ mr: 0.5 }} />}
              Must not include common words (e.g., 'password', 'admin')
            </Typography>
            <Typography variant="caption" display="flex" alignItems="center" color={passwordRules?.noUsernameSubstring ? 'success.main' : 'error.main'}>
              {passwordRules?.noUsernameSubstring ? <CheckCircleIcon fontSize="small" sx={{ mr: 0.5 }} /> : <CancelIcon fontSize="small" sx={{ mr: 0.5 }} />}
              Must not contain your username
            </Typography>
          </Box> */}

          {/* <List dense>
            <ListItem>
              <ListItemIcon>
                {passwordRules.minLength ? (
                  <CheckCircleIcon color="success" />
                ) : (
                  <CancelIcon color="error" />
                )}
              </ListItemIcon>
              <ListItemText primary="At least 12 characters long" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                {passwordRules.uppercase ? (
                  <CheckCircleIcon color="success" />
                ) : (
                  <CancelIcon color="error" />
                )}
              </ListItemIcon>
              <ListItemText primary="At least one uppercase letter (A–Z)" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                {passwordRules.lowercase ? (
                  <CheckCircleIcon color="success" />
                ) : (
                  <CancelIcon color="error" />
                )}
              </ListItemIcon>
              <ListItemText primary="At least one lowercase letter (a–z)" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                {passwordRules.number ? (
                  <CheckCircleIcon color="success" />
                ) : (
                  <CancelIcon color="error" />
                )}
              </ListItemIcon>
              <ListItemText primary="At least one number (0–9)" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                {passwordRules.specialChar ? (
                  <CheckCircleIcon color="success" />
                ) : (
                  <CancelIcon color="error" />
                )}
              </ListItemIcon>
              <ListItemText primary="At least one special character (e.g., !@#$%^&*())" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                {passwordRules?.noCommonWords ? <CheckCircleIcon color="success" /> : <CancelIcon color="error" />}
              </ListItemIcon>
              <ListItemText primary="Must not include common words (e.g., 'password', 'admin')" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                {passwordRules?.noUsernameSubstring ? <CheckCircleIcon color="success" /> : <CancelIcon color="error" />}
              </ListItemIcon>
              <ListItemText primary="Must not contain your username" />
            </ListItem>
          </List> */}

          {/* <Link
            component="button"
            onClick={handleOpenModal}
            style={{ marginTop: "5px", display: "block" }}
          >
            View Password Policy
          </Link> */}
        {/* </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={
              <Typography component="span">
                Confirm Password <span style={{ color: 'red' }}>*</span>
              </Typography>
            }

            type="password"
            placeholder="Enter Confirm Password"
            variant="outlined"
            size="small"
            value={formData?.confirm_password || ''}
            onChange={(e) => handleInputChange("confirm_password", e.target.value)}
            error={!!errors?.confirm_password}
            helperText={errors?.confirm_password}
          />
        </Grid> */}

        {/* <Grid item xs={12} sm={6}>
          <SearchableDropdown
            options={stateList}
            label="Select State"
            labelKey="state_name"
            value={formData?.location[0]?.state || null}
            onChange={handleStateChange}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <SearchableDropdown
            options={cityOptions}
            label="Select City"
            labelKey="city_name"
            value={formData.location[0]?.city || null}
            onChange={(city) => {
              const updatedLocation = [
                {
                  ...formData.location[0],
                  city: city,
                },
              ];
              setFormData({ ...formData, location: updatedLocation });
            }}
          />
        </Grid> */}
      </Grid>
      {mode !== undefined &&
        <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
          <Button variant="outlined" size="small" onClick={() => navigate(-1)}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={(e: any) => handleSubmit()}
            color="primary"
            size="small"
          >
            {mode === "edit" ? 'Update' : 'Create'}
          </Button>
        </Box>
      }
    </Box>
  );
};

export default CreateUserForm;
